import * as React from 'react';
import { createLocators } from '@u1/locators';
import { motion } from 'framer-motion';
import clsx from 'clsx';

import useStyles from './Spinner.styles';

export interface ISpinnerProps {
  /**
   * Size of the element in px
   */
  size?: number;
}

export const spinnerLocators = createLocators({
  name: 'Spinner',
  componentLocators: ['svgWrapper', 'path'],
});
const { locators } = spinnerLocators();

const circleAnimationVariants = {
  animate: {
    pathLength: [0, 1, 1],
    pathOffset: [0, 0.2, 1],
    rotate: 360,
    transition: {
      duration: 1.5,
      ease: 'linear',
      repeatType: 'loop' as const,
      repeat: Infinity,
    },
  },
};

const Spinner: React.FC<ISpinnerProps> = ({ size = 14 }) => {
  const classes = useStyles();

  return (
    <motion.svg
      {...locators.svgWrapper()}
      className={clsx(classes.root)}
      width="100%"
      height="100%"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial="start"
      animate="animate"
      style={{ width: size, height: size }}
    >
      <motion.circle
        {...locators.path()}
        cx="48"
        cy="48"
        r="40"
        fill="none"
        stroke="currentColor"
        strokeWidth="8"
        variants={circleAnimationVariants}
        strokeDasharray="0 1"
      />
    </motion.svg>
  );
};

export default Spinner;
